function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Stepper({ timeline }) {
  return (
    <nav aria-label="Progress">
      <ol role="list" className="overflow-hidden mt-4">
        {timeline.map((step, stepIdx) => (
          <li
            key={step.name}
            className={classNames(
              stepIdx !== timeline.length - 1 ? "pb-8" : "",
              "relative"
            )}
          >
            {step.status === "complete" ? (
              <>
                {stepIdx !== timeline.length - 1 ? (
                  <div
                    aria-hidden="true"
                    className="absolute left-3 top-4 -ml-px mt-0.5 h-full w-[1px] bg-[#00394d]"
                  />
                ) : null}
                <span className="group relative flex items-start">
                  <span className="flex h-9 items-center">
                    <span className="relative z-10 flex h-6 w-6 items-center justify-center rounded-full bg-[#0ba300] ">
                      check Icon
                    </span>
                  </span>
                  <span className="ml-4 flex min-w-0 flex-col">
                    <span className="text-sm font-medium">{step.name}</span>
                    <span className="text-xs text-gray-500">
                      {step.description}
                    </span>
                  </span>
                </span>
              </>
            ) : step.status === "current" ? (
              <>
                {stepIdx !== timeline.length - 1 ? (
                  <div
                    aria-hidden="true"
                    className="absolute left-3 top-4 -ml-px mt-0.5 h-full w-[1px] bg-[#00394d]"
                  />
                ) : null}
                <span
                  aria-current="step"
                  className="group relative flex items-start"
                >
                  <span aria-hidden="true" className="flex h-9 items-center">
                    <span className="relative z-10 flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#0ba300] bg-white">
                      <span className="h-2 w-2 rounded-full bg-[#0ba300]" />
                    </span>
                  </span>
                  <span className="ml-4 flex min-w-0 flex-col">
                    <span className="text-sm font-medium ">{step.name}</span>
                    <span className="text-xs text-gray-500">
                      {step.description}
                    </span>
                  </span>
                </span>
              </>
            ) : step.status === "failed" ? (
              <>
                {stepIdx !== timeline.length - 1 ? (
                  <div
                    aria-hidden="true"
                    className="absolute left-3 top-4 -ml-px mt-0.5 h-full w-[1px] bg-[#d30d00]"
                  />
                ) : null}
                <span
                  aria-current="step"
                  className="group relative flex items-start"
                >
                  <span aria-hidden="true" className="flex h-9 items-center">
                    <span className="relative z-10 flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#d30d00] bg-white">
                      <span className="h-2 w-2 rounded-full bg-[#d30d00]" />
                    </span>
                  </span>
                  <span className="ml-4 flex min-w-0 flex-col">
                    <span className="text-sm font-medium">{step.name}</span>
                    <span className="text-xs text-gray-500">
                      {step.description}
                    </span>
                  </span>
                </span>
              </>
            ) : (
              <>
                {stepIdx !== timeline.length - 1 ? (
                  <div
                    aria-hidden="true"
                    className="absolute left-3 top-4 -ml-px mt-0.5 h-full w-[1px] bg-[#00394d]"
                  />
                ) : null}
                <span className="group relative flex items-start">
                  <span aria-hidden="true" className="flex h-9 items-center">
                    <span className="relative z-10 flex h-6 w-6 items-center justify-center rounded-full border-2 border-gray-300 bg-white group-hover:border-gray-400">
                      <span className="h-2 w-2 rounded-full bg-transparent group-hover:bg-gray-300" />
                    </span>
                  </span>
                  <span className="ml-4 flex min-w-0 flex-col">
                    <span className="text-sm font-medium text-gray-500">
                      {step.name}
                    </span>
                    <span className="text-xs text-gray-500">
                      {step.description}
                    </span>
                  </span>
                </span>
              </>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
